import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || '/';
console.log("Base URL:", baseURL);

// Tworzymy instancję axios
const api = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Pomocnicza funkcja sprawdzająca, czy token jest już nieważny.
 * @param {string} token - JWT pobrany np. z localStorage.
 * @returns {boolean} true, jeśli token wygasł lub jest nieprawidłowy
 */
function isTokenExpired(token) {
    try {
        const payloadBase64 = token.split('.')[1];
        const payload = JSON.parse(atob(payloadBase64)); // dekodujemy bazę 64
        const now = Math.floor(Date.now() / 1000);

        // jeśli exp <= obecny czas (sekundy), token uznajemy za wygasły
        return payload.exp <= now;
    } catch (err) {
        // jeśli wystąpił błąd przy dekodowaniu, traktujemy token jako nieważny
        console.error('Błąd przy sprawdzaniu ważności tokena:', err);
        return true;
    }
}

export const hasValidToken = () => {
    const token = localStorage.getItem('token');
    return !!token && !isTokenExpired(token);
};

// Lista endpointów, dla których nie sprawdzamy tokena (logowanie nie może wpaść w stary, wygasły token)
const excludedEndpoints = ['/login', '/register', '/public', '/features', '/auth/token'];

const isExcludedEndpoint = (url = '') => excludedEndpoints.some((endpoint) => url.startsWith(endpoint));

// --- Request Interceptor ---
// Wykonuje się przed każdym zapytaniem do API
api.interceptors.request.use(
    (config) => {
        if (!isExcludedEndpoint(config.url)) {
            const token = localStorage.getItem('token');
            if (token) {
                // Sprawdzamy ważność tokena
                if (isTokenExpired(token)) {
                    // Sesja wygasła w trakcie pracy — wracamy do logowania bez wyskakującego okienka
                    localStorage.removeItem('token');

                    window.location.href = '/login?expired=1';

                    // Anulujemy zapytanie
                    throw new axios.Cancel('Anulowano zapytanie — token wygasł.');
                }

                // Dodajemy token do nagłówków
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// --- Response Interceptor ---
// Wykonuje się po otrzymaniu odpowiedzi z API
api.interceptors.response.use(
    (response) => {
        // Jeśli serwer zwrócił nowy token w nagłówku `X-New-Token`, zapiszmy go
        const newToken = response.headers['x-new-token'];
        if (newToken) {
            localStorage.setItem('token', newToken);
        }
        return response;
    },
    (error) => {
        // 401 przy logowaniu to błędne hasło — obsługuje je formularz, bez przeładowania strony
        if (error.response && error.response.status === 401 && !isExcludedEndpoint(error.config?.url)) {
            console.error('Błąd 401 - nieautoryzowany. Możliwe, że token wygasł lub jest nieprawidłowy.');

            localStorage.removeItem('token');
            window.location.href = '/login?expired=1';
        }
        return Promise.reject(error);
    }
);

export default api;
